import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import classes from './SiteNavADesktopLevelC.module.scss';

const SiteNavADesktopLevelC = ({ items = [] }) => (
  <div className={classes.container}>
    <div className={classes.wrapper}>
      {items.map((item) => {
        const className = item.isActive ? classes.navItemActive : classes.navItem;

        return (
          <Link
            href={item.href}
            target={item.target}
            className={className}
            key={item.href}
          >
            <span
              dangerouslySetInnerHTML={{ __html: item.heading }}
            />
            <div className={classes.caret} />
          </Link>
        );
      })}
    </div>
  </div>
);

SiteNavADesktopLevelC.propTypes = {
  items: PropTypes.array.isRequired,
};

export default SiteNavADesktopLevelC;
